import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://equdaczjeymkrrselqig.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVxdWRhY3pqZXlta3Jyc2VscWlnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzkzODQ3OTQsImV4cCI6MjA5NDk2MDc5NH0.MpHUAStl45Zpv4hznfq6QOGejh76Y33aehyteeJ3cnE";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
